var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import ProfilePicture from "./ProfilePicture.vue";
import PhoneNumber from "./PhoneNumber.vue";
import EmailAddress from "./EmailAddress.vue";
var ContactInformation = /** @class */ (function (_super) {
    __extends(ContactInformation, _super);
    function ContactInformation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ type: Object })
    ], ContactInformation.prototype, "profile", void 0);
    __decorate([
        Prop({ type: String })
    ], ContactInformation.prototype, "email", void 0);
    __decorate([
        Prop({ type: String })
    ], ContactInformation.prototype, "emailSubject", void 0);
    __decorate([
        Prop({ type: String })
    ], ContactInformation.prototype, "phoneNumber", void 0);
    ContactInformation = __decorate([
        Component({
            name: "ContactInformation",
            components: {
                ProfilePicture: ProfilePicture,
                PhoneNumber: PhoneNumber,
                EmailAddress: EmailAddress
            }
        })
    ], ContactInformation);
    return ContactInformation;
}(Vue));
export default ContactInformation;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/ContactInformation.vue
// module id = 169
// module chunks = 0 1 5